import React from "react";

export default function SospechaDisfagiaOrofaringea() {

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Usuario/a con sospecha de disfagia orofaríngea</h4>
      </div>

      {/* Signos de alarma en sospecha de disfagia orofaríngea */}
      <div className="bg-white border rounded-lg p-4 leading-relaxed text-justify">
        <h5 className="font-bold mb-3 text-center">Signos de alarma en sospecha de disfagia orofaríngea</h5>

        <p className="mb-2">
          <b>Durante la ingesta:</b>
        </p>

        <ul className="list-disc pl-6 mb-4">
          <li>Tos o carraspeo repetido durante o inmediatamente después de tragar.</li>
          <li>Cambio en la voz o voz “húmeda” / gorgoteante tras la deglución.</li>
          <li>Atragantamientos frecuentes con líquidos, sólidos o incluso saliva.</li>
          <li>Dificultad para iniciar la deglución o necesidad de múltiples intentos para tragar.</li>
          <li>Salida de alimento o líquido por la nariz (regurgitación nasal).</li>
          <li>Escape de alimento o líquido por la comisura bucal o acumulación en la cavidad oral.</li>
          <li>Sensación de que “la comida se queda pegada” en la garganta o pecho.</li>
        </ul>

        <p className="mb-2">
          <b>Después de la ingesta:</b>
        </p>

        <ul className="list-disc pl-6 mb-4">
          <li>Tos tardía o crisis de tos minutos después de comer o beber.</li>
          <li>Cambios en la saturación de oxígeno (SpO₂ ↓ ≥3%) durante o tras la comida.</li>
          <li>Dificultad respiratoria o disnea post deglución.</li>
          <li>Neumonías de repetición o fiebre sin causa aparente (posible aspiración silente).</li>
          <li>Pérdida de peso involuntaria o desnutrición progresiva.</li>
        </ul>

        <p className="mb-2">
          <b>Manifestaciones generales:</b>
        </p>

        <ul className="list-disc pl-6">
          <li>Tiempo prolongado en las comidas.</li>
          <li>Fatiga o cansancio durante la alimentación.</li>
          <li>Sialorrea (salivación excesiva) o babeo continuo.</li>
          <li>Alteraciones del nivel de conciencia o del estado cognitivo que dificultan la colaboración.</li>
          <li>Deshidratación o rechazo de líquidos.</li>
        </ul>
      </div>

      {/* Signos de alarma en sospecha de disfagia orofaríngea */}
      <div className="bg-white border rounded-lg p-4 leading-relaxed text-justify">
        <h5 className="font-bold mb-3 text-center">Signos de alarma mayores (requieren valoración inmediata)</h5>

        <ul className="list-disc pl-6 space-y-1">
          <li>Tos persistente con líquidos o alimentos.</li>
          <li>Cambio de voz húmeda tras tragar.</li>
          <li>Fiebre o neumonías recurrentes.</li>
          <li>Desaturación significativa (menor que 3%) asociada a la ingesta.</li>
          <li>Pérdida de peso rápida o signos de malnutrición.</li>
        </ul>
      </div>

      {/* Introducción EAT-10 */}
      <div className="bg-white border rounded-lg p-4 leading-relaxed text-justify">
        <h5 className="font-bold mb-3 text-center">CRIBADO DISFAGIA (EAT-10)</h5>
        <p className="mb-2">
          Debe realizar el cribado de disfagia para conocer el riesgo, o no, de deterioro de la deglución.
        </p>
        <p className="mb-2">
          El test EAT-10 permite conocer la dificultad para tragar.
        </p>
        <p className="font-semibold mb-2">
          Rellenar según la escala 0 (ningún problema) a 4 (problema serio).
        </p>
      </div>

      {/* PDF descargable debajo del cuadro */}
      <div className="bg-white border rounded-lg p-4">
        <h5 className="font-bold mb-3 text-center">DOCUMENTO EAT-10 DESCARGABLE</h5>
        <iframe
          src="/docs/eat-10_descargable.pdf"
          title="MECV-V Descargable"
          className="w-full h-[500px] border rounded-lg"
        ></iframe>
        <p className="mt-3 text-center text-gray-600">
          Puedes imprimir o guardar este documento para registrar manualmente los resultados de la prueba EAT-10.
        </p>
      </div>
    </div>
  );
}